import { CxsBasket, errorMessages } from '../model';
import { markProductUpdate, updateEntry } from '../utils';
import { setGiftOptions } from '@accelerator/basket/action-handlers/set-gift-options';

export const addGiftWrappingOptions = (
    basket: CxsBasket,
    productId: string,
    giftWrappingId: string,
    giftCardId: string,
    giftCardText: string
): CxsBasket => {
    const existingLineIndex = basket.lines.findIndex(currLine => currLine.variantNo === productId);
    const line = basket.lines[existingLineIndex];
    if (!line) {
        throw Error(errorMessages.productNotFound);
    }

    const lines = updateEntry(
        basket.lines,
        { ...setGiftOptions(line, giftWrappingId, giftCardId, giftCardText) },
        existingLineIndex
    );
    return {
        ...basket,
        lines,
        ...markProductUpdate(basket, productId)
    };
};
